import { FC, memo } from 'react';

import { StepComponentsProviderProps } from './types/StepComponentsProviderProps';
import { StepComponentsContext } from './StepComponentsContext';

const StepComponentsProviderComponent: FC<StepComponentsProviderProps> = ({
  children,
  value,
}) => (
  <StepComponentsContext.Provider value={value}>
    {children}
  </StepComponentsContext.Provider>
);

export const StepComponentsProvider = memo(StepComponentsProviderComponent);
